import React from "react";

import CustomMDEditor from "../../../components/CustomMDEditor";
import {useLocalization} from "../../../customHooks/useContextLocalization";
import {useReduxData} from "../../customHooks/useContextReduxData";
import getTimeElapsedSince from "../getTimeElapsedSince";
import {useMapDispatch} from "../../customHooks/useContextMapDispatch";


export default function TextArea() {
    const locale = useLocalization();
    const {
        isEditMode,
        selectedObject: {isTheOnlyObjectSelected, figureUuid, figureDescription},
        startTime
    } = useReduxData();
    const mapDispatch = useMapDispatch();

    const handleMDChanged = value => mapDispatch({
        type: "changeObjectDescription",
        uuid: figureUuid,
        description: value,
        time: getTimeElapsedSince(startTime)
    });

    return <CustomMDEditor
        autoFocus={true}
        className={!isEditMode || !isTheOnlyObjectSelected ? "floating-menu-md-editor-disabled" : "floating-menu-md-editor"}
        textareaProps={{
            placeholder: locale?.get.studio.floatingMenu.textAreaPlaceholder
        }}
        isShortened={true}
        value={isTheOnlyObjectSelected ? figureDescription : ""}
        onChange={handleMDChanged}
    />;
}
